module.exports = __webpack_public_path__ + "img/icon-toggle-ko.66ef3f1a.svg";